/* eslint-disable no-use-before-define */
import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";
import { Checkbox } from "@material-ui/core";

const useStyles = makeStyles({
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  inputRoot: {
    height: "49px",
  },
  inputRootLocation: {
    height: "49px",
    backgroundColor: "#FFFFFF",
    fontSize: "14px",
  },
});
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

export default function AutoSelect({
  list,
  data,
  setData,
  id,
  multipleFlag = false,
  placeHolder,
  disabled = false,
  width,
  searchText,
}) {
  const classes = useStyles();

  const initialValue = list.filter(
    (o) => id === "language" && data[id]?.some((b) => b.id === o.id)
  );

  return (
    <Autocomplete
      multiple={multipleFlag === true ? true : false}
      id={id}
      value={id === "language" && multipleFlag ? initialValue : data[id]}
      onChange={(event, value) => {
        setData({ ...data, [id]: value });
      }}
      options={list}
      classes={{
        option: classes.option,
        inputRoot:
          id === "locations" ? classes.inputRootLocation : classes.inputRoot,
      }}
      disabled={disabled}
      disableClearable={id === "locations"}
      disableCloseOnSelect={id === "language" && multipleFlag}
      getOptionLabel={(option) => option.name || ""}
      renderTags={(value, getTagProps) => {
        if (id === "locations") return null;
        if (multipleFlag && id !== "locations") {
          return (
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "98%",
              }}
            >
              {value.map((option) => option.name).join(", ")}
            </span>
          );
        }
        return value.map((option, index) => option.name);
      }}
      renderOption={
        id === "language" && multipleFlag
          ? (option, { selected }) => {
              return (
                <li key={option.id}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    checked={selected}
                  />
                  {option.name}
                </li>
              );
            }
          : (option) => <React.Fragment>{option.name}</React.Fragment>
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          inputProps={{
            ...params.inputProps,
          }}
          placeholder={
            multipleFlag && id !== "locations" && data[id].length > 0
              ? ""
              : placeHolder
          }
          disabled={disabled}
          onChange={
            (event) => {
              const inputValue = event.target.value;
              if (searchText) {
                setData({ ...data, [searchText]: inputValue });
              }
            } // Update the data state when input changes
          }
        />
      )}
    />
  );
}
